"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSafeOffset = exports.getSafeXY = exports.getSafeIJ = exports.getSafe = exports.getUnsafe = exports.inRange = exports.clear = exports.create = exports.getSize = exports.exists = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveTilemap_generic_sidecar_1 = require("./diveTilemap_generic-sidecar");
var _obj = null;
function get() {
    assert_sidecar_1.assert.notNil(_obj, 'tilemap hyperspace not created');
    return _obj;
}
exports.get = get;
function exists() {
    return _obj !== null;
}
exports.exists = exists;
function getSize() {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getSize(get());
}
exports.getSize = getSize;
function create() {
    _obj = diveTilemap_generic_sidecar_1.diveTilemap_generic.create(16, 16);
    return _obj;
}
exports.create = create;
function clear() {
    diveTilemap_generic_sidecar_1.diveTilemap_generic.clear(get());
}
exports.clear = clear;
function inRange(i, j) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.inRange(get(), i, j);
}
exports.inRange = inRange;
function getUnsafe(i, j) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getUnsafe(get(), i, j);
}
exports.getUnsafe = getUnsafe;
function getSafe(i, j) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getSafe(get(), i, j);
}
exports.getSafe = getSafe;
function getSafeIJ(iij) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getSafeIJ(get(), iij);
}
exports.getSafeIJ = getSafeIJ;
function getSafeXY(ixy) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getSafeXY(get(), ixy);
}
exports.getSafeXY = getSafeXY;
function getSafeOffset(iij, oi, oj) {
    return getSafe(iij.i + oi, iij.j + oj);
}
exports.getSafeOffset = getSafeOffset;
